import * as React from 'react'

export const useKeyBinding = (callback?: (e: KeyboardEvent) => void) => {
  React.useEffect(() => {
    document.addEventListener('keydown', e => callback && callback(e), true)

    return () => document.removeEventListener('keydown', e => callback && callback(e), true)
  }, [callback])
}
